import { createReducer } from "@reduxjs/toolkit";
import { setIsTourModalOpen, setIsTourRunning, setTourStep } from "./actions";

const initialState = {
  isTourModalOpen: false,
  isTourRunning: false,
  tourStep: 0,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(setIsTourModalOpen.type, (state, { payload }) => ({
      ...state,
      isTourModalOpen: payload,
    }))
    .addCase(setIsTourRunning.type, (state, { payload }) => ({
      ...state,
      isTourRunning: payload,
    }))
    .addCase(setTourStep.type, (state, { payload }) => ({
      ...state,
      tourStep: payload,
    }));
});
